import api from "../api/api";

export const getClientes = async () => {
  const response = await api.get("/clients"); 
  return response.data;
};

export const createCliente = async (clienteData) => {
  const response = await api.post("/clients", clienteData);
  return response.data;
};